import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { EmailSignupBlock } from "../EmailSignupBlock";

/**
 * toppers HomePage ``email_signup`` assembly: a single ``{% include_react %}``
 * island over the single-block ``email_signup`` StreamField.
 *
 * The ``email_signup`` block dispatches to the ``EmailSignupBlock`` component,
 * which keeps the load-bearing hydration contract intact: it gates on
 * ``value.email_signup_status === "active"`` and emits the bare
 * ``<div data-place-react="email-signup-modal" />`` mount point (the modal still
 * hydrates client-only via ``dynamicPlaceComponent``). See EmailSignupBlock.tsx
 * for the full hydration rationale.
 *
 * ``tagName={React.Fragment}``: the assembly emits no wrapper element.
 */
export const homeEmailSignupComponentsMap = {
    email_signup: EmailSignupBlock,
} as const;

export const HomePageEmailSignup = (
    props: Immutable<{
        page: Pick<templates.HomePageTemplate["page"], "email_signup">;
    }>,
): React.JSX.Element | null => {
    const emailSignup = props.page.email_signup;
    if (!emailSignup) {
        return null;
    }
    return (
        <StreamField
            tagName={React.Fragment}
            value={emailSignup.value}
            components={homeEmailSignupComponentsMap}
        />
    );
};
